import type { Permission} from "@@/shared/auth/scopes/permission";
import { permissions } from "@@/shared/auth/scopes/permission";
import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { ProviderId} from "../provider-id";
import { providerIdZodSchema } from "../provider-id";

type ProviderAddUserCommand = {
    readonly _id: string;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _type: "PROVIDER_ADD_USER_COMMAND";

    readonly userId: UserId;
    readonly providerId: ProviderId;
    readonly permission: Permission;
};

type ProviderAddUserCommandResponse = {
    readonly _id: string;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _type: "PROVIDER_ADD_USER_COMMAND_RESPONSE";
};

type FactoryParams = Except<
    ProviderAddUserCommand,
    "_id" | "_type" | "_createdAt"
>;
type ResponseFactatoryParams = Except<
    ProviderAddUserCommandResponse,
    "_id" | "_type" | "_createdAt"
>;
const providerAddUserCommandFactory = (params: FactoryParams) => {
    const initiateStripePaymentCommand: ProviderAddUserCommand = {
        ...params,
        _id: generateId({ prefix: "provider_add_user_command__" }),
        _type: "PROVIDER_ADD_USER_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return initiateStripePaymentCommand;
};

const providerAddUserCommandFactoryResponse = (
    params: ResponseFactatoryParams,
) => {
    const response: ProviderAddUserCommandResponse = {
        ...params,
        _id: generateId({ prefix: "provider_add_user_command_response__" }),
        _type: "PROVIDER_ADD_USER_COMMAND_RESPONSE",
        _createdAt: nowIsoAndUnix(),
    };
    return response;
};

const providerAddUserCommandZodSchema: z.ZodSchema<ProviderAddUserCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("PROVIDER_ADD_USER_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        userId: userIdZodSchema,
        providerId: providerIdZodSchema,
        permission: z.enum(permissions),
    });

export {
    providerAddUserCommandFactory,
    providerAddUserCommandFactoryResponse,
    providerAddUserCommandZodSchema,
};
export type { ProviderAddUserCommand, ProviderAddUserCommandResponse };
